import { inject, Injectable } from '@angular/core';
import { InvestigationTypeState } from '../../states/investigation-type.state';
import { Observable } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { GetChecklistResult } from './get-checklist.result';
import { ChecklistRepository } from '../../../infrastructure/repositories/checklist.repository';

@Injectable({ providedIn: 'root' })
export class GetChecklistUseCase {
  private readonly _repository = inject(ChecklistRepository);
  private readonly _state = inject(InvestigationTypeState);

  public execute(investigationTypeId: string): Observable<GetChecklistResult> {
    this._state.setLoadingChecklist(true);
    this._state.clearErrorChecklist();

    return this._repository.getChecklist(investigationTypeId).pipe(
      tap(() => {
        this._state.setLoadingChecklist(false);
      }),
      map((details) => ({ details })),
      catchError((error) => {
        if (error?.status !== 404) {
          const errorMessage = error?.error?.message || error?.message || 'Failed to load checklist';
          this._state.setErrorChecklist(errorMessage);
        }
        this._state.setLoadingChecklist(false);
        throw error;
      }),
    );
  }
}
